import { useMutation, useQueryClient } from "@tanstack/react-query";
import { toast } from "react-toastify";
import CustomToast from "src/components/CustomToast/CustomToast";
import cmsClient from "src/services/cmsClient";
import { BlockedHashtag } from "./useBlockedHashtags";

const createBlockedHashtag = async (word: string): Promise<BlockedHashtag> => {
	const response = await cmsClient.post<BlockedHashtag>(
		"/homepage/admin/hashtags/blocked/",
		{ word }
	);

	return response.data;
};

const useCreateBlockedHashtag = () => {
	const queryClient = useQueryClient();

	const onSuccess = () => {
		toast.success(
			<CustomToast type="Success" message="Blocked word added successfully" />,
			{ hideProgressBar: true }
		);

		queryClient.invalidateQueries(["blocked-hashtags"]);
	};

	const onError = () => {
		toast.error(
			<CustomToast type="Error" message="Something went wrong, try again" />,
			{ hideProgressBar: true }
		);
	};

	return useMutation(createBlockedHashtag, {
		onError,
		onSuccess
	});
};

export default useCreateBlockedHashtag;
